import { TRACK_OWNER_IDX } from '~/common/constants/constants';
import { AppLocalizationKey, MentorsPayload } from '~/common/types/types';
import margarytaRovna from '~/assets/img/mentors/margaryta-rovna.png';
import maksymVinnik from '~/assets/img/mentors/maksym-vinnik.png';
import nataliaDulepa from '~/assets/img/mentors/natalia-dulepa.png';
import serhiiNazarchuk from '~/assets/img/mentors/serhii-nazarchuk.png';
import stanislavHorkusha from '~/assets/img/mentors/stanislav-horkusha.png';
import oksanaRemeslova from '~/assets/img/mentors/oksana-remeslova.png';
import zorianaChyzhovska from '~/assets/img/mentors/zoriana-chyzhovska.png';

const MENTORS = [
  margarytaRovna,
  maksymVinnik,
  nataliaDulepa,
  serhiiNazarchuk,
  stanislavHorkusha,
  oksanaRemeslova,
  zorianaChyzhovska,
];

const mentorsPayload: MentorsPayload = {
  title: 'technology.qa.mentors.title',
  items: MENTORS.map((it, idx) => ({
    name: `technology.qa.mentors.mentor${idx}` as AppLocalizationKey,
    imgPath: it,
    isTrackOwner: idx === TRACK_OWNER_IDX,
  })),
};

export { mentorsPayload };
